import { IntervalSelectorProps, IntervalSelectorStateProps } from '../../types/components/pricing/IntervalSelector';
import { SubscriptionDetail } from '../../types/api/SubscriptionTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import { SwitchButtonMinimal } from '../../modules/SwitchButton';

import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { ENTERPRISE_PRICING_PAGE_URL, DEFAULT_PLAN_VARIANT_INTERVAL_SELECTION } from '../../constants/ui';

export const yearlyOrEnterpriseTagStyle = 'bg-[#e3cc00] !text-black';
export const monthlyTagStyle = 'bg-[#7F898D] !text-white';

const IntervalSelector: React.FC<IntervalSelectorProps> = ({
  selectedInterval,
  setSelectedInterval,
  intervalTag,
  subscription,
}) => {
  const router = useRouter();

  const toggleButton = () => {
    switch (selectedInterval) {
      case 'month':
        setSelectedInterval('year');
        break;
      case 'year':
      default:
        setSelectedInterval('month');
        break;
    }
  };

  const getTagStyle = (): string => {
    if (selectedInterval === 'year' || router.asPath.includes(ENTERPRISE_PRICING_PAGE_URL))
      return yearlyOrEnterpriseTagStyle;
    return monthlyTagStyle;
  }

  useEffect(() => {
    subscription?.id ?
      setSelectedInterval(subscription?.plan_variant?.interval || DEFAULT_PLAN_VARIANT_INTERVAL_SELECTION) :
      setSelectedInterval(DEFAULT_PLAN_VARIANT_INTERVAL_SELECTION);
  }, [subscription]);

  return (
    <section className="flex flex-col items-center justify-center gap-4 pb-12 lg:flex-row lg:pb-8" cy-test-id="interval-selector">
      <SwitchButtonMinimal
        textLeft="Monthly"
        textRight="Yearly"
        buttonLeft={selectedInterval === 'month'}
        buttonRight={selectedInterval === 'year'}
        className="text-white bg-transparent rounded-full py-3 px-6 !w-[224px]"
        onClick={toggleButton}
      />
      <div
        className={`
          ${getTagStyle()}
          w-[191px] h-[24px] rounded-[5px] text-[12px] font-bold uppercase tracking-wide flex items-center justify-center leading-[20px]`
        }
        cy-test-id="interval-tag"
      >
        {intervalTag}
      </div>
    </section>
  );
}

const mapStateToProps = (state: ApplicationState): IntervalSelectorStateProps => ({
  subscription: state.auth.subscription as SubscriptionDetail,
})

export default connect(mapStateToProps)(IntervalSelector);
